import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Tag } from '../tag/_Tag';
var StyledTag = styled(Tag)(_templateObject());
export var Plus = function Plus(_ref) {
  var number = _ref.number;

  if (number <= 0) {
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement(StyledTag, null, "+", Math.min(number, 99))
  );
};